import { selectAISummaryApiUrl } from 'util/selector/apiSelector';

import axios, { AxiosInstance } from 'axios';
import Cookies from 'universal-cookie';
import { AUTH_TOKEN_COOKIE } from 'shared/constants/cookies';

import { attachRetryWithRefreshOn401Interceptor } from './retryWithRefreshOn401';

export const aiSummaryClient: AxiosInstance = axios.create({
  baseURL: selectAISummaryApiUrl(),
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'en-GB',
    Accept: 'application/json',
  },
});

aiSummaryClient.interceptors.request.use((config) => {
  const authToken = new Cookies().get(AUTH_TOKEN_COOKIE);

  if (authToken && config.headers) {
    config.headers['Authorization'] = `Bearer ${authToken}`;
  }

  return config;
});

attachRetryWithRefreshOn401Interceptor(aiSummaryClient);
